import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { SharedModule } from "@app/shared/shared.module";
import { ManualComponent } from "./manual.component";
import { ApiPowerBIUsageComponent } from "./pages/manual-pages/apis/api-powerbi-usage/api-powerbi-usage.component";
import { ApiUsageManualComponent } from "./pages/manual-pages/apis/api-usage-manual/api-usage-manual.component";
import { ApiManualSectionComponent } from "./pages/manual-sections/ApiManualSection.component";
import { ManualDataService } from "./services/manual-data.service";

@NgModule({
    imports: [CommonModule, SharedModule, ApiUsageManualComponent, ApiPowerBIUsageComponent],
    declarations: [
        ManualComponent,

        ApiManualSectionComponent,
    ],
})
export class ManualModule {
    static forRoot(): ModuleWithProviders<ManualModule> {
        return {
            ngModule: ManualModule,
            providers: [ManualDataService],
        };
    }
}
